import { fallback } from '@tanstack/router-zod-adapter';
import z from 'zod';

export const keyPortsSearchSchema = z.object({
    searchQuery: fallback(z.string(), '').default(''),
    customerGroupIds: fallback(z.array(z.string()), []).default([]),
    page: fallback(z.number(), 0).default(0),
});
